import {
  setMessageVisibility,
  getCarData,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';

const obfuscation = {
  showQuotationRegistrationNumberObfuscatedMessage(initialRun?: boolean) {
    const { registrationNumber } = getCarData();

    const showObfuscatedMessage = checkIsDataObfuscated(
      registrationNumber,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.QuotationRegistrationNumberObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });
  },
  showQuotationCarVinObfuscatedMessage(initialRun?: boolean) {
    const { vin } = getCarData();

    const showObfuscatedMessage = checkIsDataObfuscated(vin, initialRun);

    setMessageVisibility({
      key: MessagesEnum.QuotationCarVinObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default obfuscation;
